import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authReducer';
import analysisReducer from './analysisReducer';
import uploadReducer from './uploadReducer';
import reportReducer from './reportReducer';

// Re-export auth actions for convenience
export {
  loginRequest,
  loginSuccess,
  loginFailure,
  logout,
  setUser
} from './authReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  analysis: analysisReducer,
  upload: uploadReducer,
  report: reportReducer,
});

export default rootReducer;